export default {
    namespaced: true,
    state: {
        sourceLinks: [],
    },
    getters: {
        getSourceLink: state => blockId => state.sourceLinks.find(el => el.blockId === blockId)?.value,
        getSourceLinkTouched: state => blockId => state.sourceLinks.find(el => el.blockId === blockId)?.touched,
    },
    mutations: {
        setSourceLinkTouched(state, payload) {
            const { touched, blockId } = payload;

            const foundBlock = state.sourceLinks.some(el => {
                if (el.blockId === blockId) {
                    el.touched = touched;

                    return true;
                }

                return false;
            });

            if (!foundBlock) {
                state.sourceLinks.push({
                    touched,
                    blockId,
                });
            }
        },
        SET_SOURCE_LINK(state, payload) {
            const { value, blockId } = payload;


            const foundBlock = state.sourceLinks.some(el => {
                if (el.blockId === blockId) {
                    el.value = value;

                    return true;
                }

                return false;
            });

            if (!foundBlock) {
                state.sourceLinks.push({
                    value,
                    blockId,
                });
            }
        },
    },
};
